<template>
  <span>{{ moneyFormat }}</span>
</template>

<script>
export default {
  name: 'FormatMoney',
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    moneyFormat() {
      const str = this.value;
      return (+str) ? (+str).toFixed(0).replace(/\d(?=(\d{3})+$)/g, '$& ') : str;
    },
  },
};
</script>

<style scoped>

</style>
